export default "__VITE_ASSET__$HDJzfZK__"